import { render, staticRenderFns } from "./VesselQuickViewModal.vue?vue&type=template&id=2bc57770&"
import script from "./VesselQuickViewModal.vue?vue&type=script&lang=js&"
export * from "./VesselQuickViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports